import introJs from "intro.js";
import "intro.js/introjs.css"; // intro.js的基础样式文件
// import "intro.js/themes/introjs-modern.css"; // 主题样式文件

const intro = introJs();

intro.setOptions({
  // nextLabel: "下一步", // 下一个的按钮文字
  // prevLabel: "上一步", // 上一个按钮文字
  // skipLabel: "跳过", // 跳过指引的按钮文字
  // doneLabel: "完成", // 完成按钮的文字
  showStepNumbers: false, // 隐藏步骤点
  showButtons: false, // 是否显示按钮
  hidePrev: false, // 是否在第一步中隐藏“上一步”按钮;不隐藏，将呈现为一个禁用的按钮
  hideNext: false, // 是否在最后一步中隐藏“下一步”按钮（同时会隐藏完成按钮);不隐藏，将呈现为一个禁用的按钮
  exitOnEsc: false, // 点击键盘的ESC按钮是否退出指引
  exitOnOverlayClick: false, // 点击遮罩层时是否退出介绍
  disableInteraction: true, // 是否禁用高亮显示框内元素的交互
  showBullets: false, // 是否显示面板的指示点
  overlayOpacity: 0.4, // 遮罩层的透明度 0-1之间
  helperElementPadding: 10, // 选中的指引元素周围的填充距离
  showSkipButton: false, // 隐藏关闭按钮
});

export default intro;
